module.exports = __webpack_public_path__ + "img/cursoExpirado.fd837019.png";